import Keycloak from "keycloak-js";

const keycloak = new Keycloak({
  url: "https://vault.nubits.net", // Keycloak server URL
  realm: "selllifi",             // Replace with your realm
  clientId: "sellifi-operatrack",      // Replace with your client ID
});

export default keycloak;
